import { FC, useEffect } from 'react';
import { useI18n, useSelector } from '~Hooks';

const OrderIdMaster: FC = () => {
  const print = useSelector((state) => state.POSReceiptPrints);
  const order = useSelector((state) => print && state.POSOrders.find((o) => o.id === print.id));
  const { i18n } = useI18n();

  useEffect(() => {
    if (!print || !order?.orderNumber || !order?.noReceipt) {
      return;
    }

    const orderNumber = order.orderNumber.padStart(3, '0');

    const message = [
      { content: ' ' },
      { content: ' ' },
      { content: ' ' },
      { content: ' ' },
      { content: ' ' },
      { content: `  ${i18n('SSK.YourOrderNumber')}  `, fontSize: 24 },
      { content: ` ${orderNumber} `, fontSize: 96 },
      { content: ' ' },
      { content: ' ' },
      { content: ' ' },
      { content: ' ' },
      { content: ' ' },
      { content: i18n('SSK.OrderNumber.PoweredBy'), fontSize: 12 },
    ];

    window.printerManager?.initiatePrint({
      data: message,
      printType: 'EPOS_ORDER_NUMBER',
    });
  }, [print, order]);

  return null;
};

export default OrderIdMaster;
